export default function initLightGallery () {
  $('.product-images, .poi-images').lightGallery({
    selector: 'a',
    getCaptionFromTitleOrAlt: false,
    download: false,
    speed: 0,
    startClass: ''
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/lightGallery.js